module.exports = {
  google: {
    API_KEY: process.env.REACT_APP_GOOGLE_API_KEY || "",
    CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
    SECRET: process.env.REACT_APP_GOOGLE_SECRET || "",
  },
  facebook: {
    APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID || "",
  },
  api: {
    API_URL: process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api",
  },
};
